import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component'
// import Breadcrumb from '../common/breadcrumb';
import CountUp from 'react-countup';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { ComposedChart, LineChart, Cell, LabelList, BarChart, Bar, Line, Legend, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import 'react-circular-progressbar/dist/styles.css';


const Homepage = props => {
    const formColorMap = [
        '#10B981', // green
        '#3B82F6', // blue
        '#F59E0B', // yellow
        '#EC4899', // pink
        '#8B5CF6', // purple
        '#EF4444', // red
        '#14B8A6', // teal
    ];
    const glowingIcon = L.divIcon({
        className: "", // leave blank so only our HTML applies
        html: `<div class="glow-circle"></div>`,
        iconSize: [70, 70],   // overall container size
        iconAnchor: [0, 0], // anchor in the center
    });
    const FitBounds = ({ clusters }) => {
        const map = useMap();

        useEffect(() => {
            if (clusters.length > 0) {
                const bounds = L.latLngBounds(
                    clusters.map(c => [c.latitude, c.longitude])
                );
                map.fitBounds(bounds, { padding: [50, 50] }); // add padding so points aren’t at edges
            }
        }, [clusters, map]);

        return null;
    };

    const getFormColor = (index) => {
        return formColorMap[index % formColorMap.length]; // loop if more forms than colors
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [attendanceRate, setAttendanceRate] = useState({ attendance_rate: 0 });
    const [attendanceByForm, setAttendanceByForm] = useState([]);
    const [monthlyData, setMonthlyData] = useState({});
    const [trendRows, setTrendRows] = useState([]);
    const [dailyAbsences, setDailyAbsences] = useState([]);
    const [progressiveAbsences, setProgressiveAbsences] = useState([]);
    const [granularity] = useState("monthly");
    const [trendByForm, setTrendByForm] = useState(null);
    const [selectedClassId, setSelectedClassId] = useState('all');
    // Get today's date in YYYY-MM format
    const today = new Date();
    const currentMonth = today.toISOString().slice(0, 7);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [classMonthlyData, setClassMonthlyData] = useState({});
    const [loadingTrendByForm, setLoadingTrendByForm] = useState(true);

    const [loadingMonthly, setLoadingMonthly] = useState(false);
    const [locationClusters, setLocationClusters] = useState([]);
    const [loadingClusters, setLoadingClusters] = useState(false);
    const [selectedClusterDate, setSelectedClusterDate] = useState(
        new Date().toISOString().slice(0, 10) // default today
    );
    const [classSummary, setClassSummary] = useState(null);
    const [loadingClassSummary, setLoadingClassSummary] = useState(false);

    const [fullScreen, setFullScreen] = useState(false);

    const [state, setState] = useState({
        // total_amount: 0,
        // average_amount: 0,
        totalStudent: 0
    })
    const [unrecorded, setUnrecorded] = useState(0);
    const [claimParents, setClaimedParents] = useState(0);

    useEffect(() => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        };

        setLoadingClusters(true);
        API.get('/analytics/attendance/locationClusters', {
            headers,
            params: { radius: 30, is_portal: true, date: selectedClusterDate }
        })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setLocationClusters(response.data.data || []);
                } else {
                    toast.error(response.data.message || "Failed to fetch clusters");
                    setLocationClusters([]);
                }
            })
            .catch(err => {
                toast.error(err.message || "Cluster API failed");
                setLocationClusters([]);
            })
            .finally(() => setLoadingClusters(false));
    }, [selectedClusterDate]);
    useEffect(() => {
        const fetchClassSummary = async () => {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': localStorage.getItem('token'),
            };

            const selectedDate = `${selectedMonth}-01`; // use month start

            setLoadingClassSummary(true);
            try {
                const res = await API.post(
                    '/attendance/attendanceSummaryByClassView',
                    {
                        is_portal: true,
                        filter_type: 'month',
                        date: selectedDate,
                    },
                    { headers }
                );

                if (res.data.response_code === 1000) {
                    setClassSummary(res.data.data);
                } else {
                    toast.error(res.data.message || 'Failed to load class summary');
                    setClassSummary(null);
                }
            } catch (err) {
                toast.error(err.message || 'Error fetching class summary');
                setClassSummary(null);
            } finally {
                setLoadingClassSummary(false);
            }
        };

        fetchClassSummary();
    }, [selectedMonth]);

    const [classes, setClass] = useState([]);
    const [columns] = useState([
        {
            name: "Class Name",
            selector: (row) => row.class_name,
            sortable: true,
            center: true,
            grow: 2
        },
        {
            name: "Total Students",
            selector: (row) => row.total_students, // Adjust field name to match your backend data
            sortable: true,
            center: true,
        },
        {
            name: "Checked In",
            selector: (row) => row.total_checked_in, // Adjust field name to match your backend data
            sortable: true,
            center: true,
        },
        {
            name: "Total MC",
            selector: (row) => row.total_mc,
            sortable: true,
            center: true,
        },
        {
            name: "Attendance Rate (%)",
            selector: (row) => row.attendance_rate?.toFixed(2), // Ensure 2 decimal points
            sortable: true,
            center: true,
        },
    ]);
    const fetchClassMonthlyAttendance = async ({ classId, month } = {}) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        if (!classId || classId === "all" || !month) {
            setClassMonthlyData({});
            return;
        }

        try {
            setLoadingMonthly(true);
            const res = await API.get('/analytics/attendance/monthlyAverage', {
                headers,
                params: { is_portal: true, class_id: classId, month }
            });

            if (res.data.response_code === 1000) {
                setClassMonthlyData(res.data.data || {});
            } else {
                toast.error(res.data.message || 'Failed to fetch class monthly attendance', { autoClose: 5000 });
                setClassMonthlyData({});
            }
        } catch (err) {
            toast.error(err?.message || 'Failed to fetch class monthly attendance', { autoClose: 5000 });
            setClassMonthlyData({});
        } finally {
            setLoadingMonthly(false);
        }
    };

    useEffect(() => {
        if (classes.length > 0) {
            const defaultClassId = classes[0]?.class_id ?? classes[0]?.id;
            setSelectedClassId(defaultClassId);
            fetchClassMonthlyAttendance({ classId: defaultClassId, month: selectedMonth });
        }
    }, [classes]);

    useEffect(() => {
        fetchClassMonthlyAttendance({ classId: selectedClassId, month: selectedMonth });
    }, [selectedClassId, selectedMonth]);

    useEffect(() => {
        // const first_time_login = localStorage.getItem('first_time_login')
        // if (first_time_login==1) {
        var headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        }
        API.get('/portal/totalStudent', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setState(response.data.data)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalUnrecordedStudent', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setUnrecorded(response.data.data.totalStudent)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalParentsClaimed', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setClaimedParents(response.data.data.totalStudent)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalStudentClass', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                const fetchedClasses = response.data.data || [];
                setClass(fetchedClasses);

                if (fetchedClasses.length > 0) {
                    setSelectedClassId(fetchedClasses[0].class_id ?? fetchedClasses[0].id);
                }
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.post('/portal/attendanceRateByForm', {}, { headers }).then(response => {
            if (response.data.code === 1000) {
                setAttendanceByForm(response.data.data);
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 });
            }
        });
        API.post('/portal/todayAttendanceRate', {}, { headers }).then(response => {
            if (response.data.code === 1000) {
                setAttendanceRate(response.data.data);
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 });
            }
        });
        API.get('/analytics/attendance/monthlyAverage', { headers, params: { is_portal: true, month: selectedMonth } }).then(response => {
            if (response.data.response_code === 1000) {
                setMonthlyData(response.data.data || {});
            } else {
                toast.error(response.data.message || "Failed to fetch trend", { autoClose: 5000 });
            }
        });
        API.get('/analytics/attendance/trend', { headers, params: { is_portal: true, month: selectedMonth } })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setTrendRows(response.data.data.trendRows || []);
                    setDailyAbsences(response.data.data.dailyAbsences || []);
                    setProgressiveAbsences(response.data.data.progressiveAbsences || []);
                } else {
                    toast.error(response.data.message || "Failed to fetch attendance trend", { autoClose: 5000 });
                }
            });
        API.get('/analytics/attendance/trendByForm', { headers, params: { is_portal: true, granularity } })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setTrendByForm(response.data.data || {});
                } else {
                    toast.error(response.data.message || "Failed to fetch trend by form", { autoClose: 5000 });
                }
            });

    }, [selectedMonth]);

    useEffect(() => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        };

        setLoadingTrendByForm(true);
        API.get('/analytics/attendance/trendByForm', {
            headers,
            params: { is_portal: true, granularity }
        })
            .then(response => {
                if (response.data.response_code === 1000) {
                    const data = response.data.data;
                    if (granularity === "monthly") {
                        setTrendByForm(Array.isArray(data) ? data : []);
                    } else {
                        setTrendByForm(typeof data === "object" && !Array.isArray(data) ? data : {});
                    }
                } else {
                    toast.error(response.data.message || "Failed to fetch trend by form", { autoClose: 5000 });
                    setTrendByForm([]);
                }
            })
            .finally(() => setLoadingTrendByForm(false));
    }, [granularity]);

    // Merge attendance, dailyAbsences, and progressiveAbsences into one dataset
    const combinedTrendData = React.useMemo(() => {
        const map = {};

        // Base attendance data
        trendRows.forEach(row => {
            map[row.date] = { ...(map[row.date] || {}), date: row.date, attendance_rate: row.attendance_rate };
        });

        // Daily absences
        dailyAbsences.forEach(row => {
            if (!map[row.date]) map[row.date] = { date: row.date };
            map[row.date].daily_absent_rate = row.absent_rate;
        });

        // Progressive absences
        progressiveAbsences.forEach(row => {
            if (!map[row.date]) map[row.date] = { date: row.date };
            map[row.date].progressive_absent_rate = row.absent_rate;
        });

        // Return sorted by date
        return Object.values(map).sort((a, b) => new Date(a.date) - new Date(b.date));
    }, [trendRows, dailyAbsences, progressiveAbsences]);

    const totalStudentsLocation = locationClusters.reduce((s, c) => s + c.count, 0);

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12 xl-100">
                        <div className="row">
                            <div className="col-xl-6 col-lg-12">
                                <DashboardCard
                                    mainComponent={
                                        loadingMonthly ? (
                                            <Skeleton width={80} height={24} />
                                        ) : (
                                            <>
                                                <span>
                                                    &nbsp;
                                                    <CountUp className="counter" end={attendanceRate.attendance_count} separator="," />
                                                </span>
                                                <span>
                                                    &nbsp;(
                                                    <CountUp className="counter" end={attendanceRate.attendance_percentage} />%)
                                                </span>
                                            </>
                                        )
                                    }
                                    subComponent={
                                        <span className="text-red font-weight-bold">
                                            {loadingMonthly ? <Skeleton width={120} /> : 'Total Attendance Students (Today)'}
                                        </span>
                                    }
                                />

                            </div>

                            <div className="col-xl-6 col-lg-12">
                                <DashboardCard
                                    mainComponent={
                                        <>
                                            <span>
                                                &nbsp;
                                                <CountUp
                                                    className="counter"
                                                    end={attendanceRate.total_mc}
                                                    separator=","
                                                />
                                            </span>
                                            <span>
                                                &nbsp;
                                                (
                                                <CountUp
                                                    className="counter"
                                                    end={attendanceRate.mc_percentage}

                                                />
                                                %)
                                            </span>
                                        </>
                                    }
                                    subComponent={
                                        <span className="text-red font-weight-bold">
                                            Total MC Students (Today)
                                        </span>
                                    }
                                />
                            </div>

                            <div className="col-xl-6 col-lg-12">
                                <DashboardCard
                                    mainComponent={
                                        <>
                                            <span>
                                                &nbsp;
                                                <CountUp className="counter" end={monthlyData.monthly_average_attendance_rate || 0} decimals={2} />%
                                            </span>
                                        </>
                                    }
                                    subComponent={
                                        <span className='text-red font-weight-bold'>
                                            Monthly Average Attendance Rate
                                        </span>
                                    }
                                />
                            </div>
                            <div className="col-xl-6 col-lg-12">
                                <DashboardCard
                                    mainComponent={
                                        <>
                                            <span>
                                                &nbsp;
                                                <CountUp className="counter" end={state.totalStudent} separator="," />
                                            </span>
                                            &nbsp;
                                        </>}
                                    subComponent={
                                        <>
                                            <span className='text-red font-weight-bold'>
                                                Total Registered Students
                                            </span><br />
                                            <span className="ml-2 text-sm px-2 py-0.5 rounded-full bg-orange-100 text-orange-800 font-medium">
                                                Face Not Recorded: {unrecorded}
                                            </span>
                                            <br />
                                            <span className="ml-2 text-sm px-2 py-0.5 rounded-full bg-orange-100 text-orange-800 font-medium">
                                                Parents Connected: {claimParents}{" "}
                                                ({state.totalStudent > 0
                                                    ? ((claimParents / state.totalStudent) * 100).toFixed(1)
                                                    : "0.0"
                                                }%)
                                            </span>


                                        </>
                                    }
                                />
                            </div>
                                         {classSummary && (
                                <div
                                    className={`col-12 mt-4 ${fullScreen ? "position-fixed top-0 start-0 w-100 h-100 bg-white z-50 p-4 overflow-auto" : ""
                                        }`}
                                    style={{
                                        transition: "all 0.3s ease-in-out",
                                        zIndex: fullScreen ? 1050 : "auto",
                                    }}
                                >
                                    <div className="card rounded-25 shadow-sm border-0 h-100">
                                        <div className="card-header bg-white text-red d-flex justify-content-between align-items-center flex-wrap gap-2">
                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                <h5 className="mb-0">Class Attendance Summary</h5>

                                                {/* 🗓️ Month Filter */}
                                                <input
                                                    type="month"
                                                    className="form-control form-control-sm w-auto"
                                                    value={selectedMonth}
                                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                                    max={new Date().toISOString().slice(0, 7)}
                                                />
                                            </div>

                                            <div className="d-flex align-items-center gap-3">
                                                {loadingClassSummary && (
                                                    <span className="text-muted small me-3">Loading...</span>
                                                )}
                                                {/* 🔍 Fullscreen toggle button */}
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => setFullScreen(!fullScreen)}
                                                >
                                                    {fullScreen ? "Exit Fullscreen" : "Expand View"}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body p-0">
                                            {!classSummary || loadingClassSummary ? (
                                                <Skeleton height={300} />
                                            ) : (
                                                <div
                                                    className="table-responsive"
                                                    style={{
                                                        maxHeight: fullScreen ? "80vh" : "60vh",
                                                        overflowY: "auto",
                                                        overflowX: "auto",
                                                    }}
                                                >
                                                    <table
                                                        className="table table-hover table-sm align-middle text-center mb-0"
                                                        style={{
                                                            borderCollapse: "separate",
                                                            borderSpacing: 0,
                                                            minWidth: "900px",
                                                            fontSize: fullScreen ? "1rem" : "0.9rem",
                                                        }}
                                                    >
                                                        <thead
                                                            className="table-light sticky-top"
                                                            style={{
                                                                top: 0,
                                                                zIndex: 5,
                                                                backgroundColor: "#f8f9fa",
                                                            }}
                                                        >
                                                            <tr>
                                                                <th
                                                                    style={{
                                                                        position: "sticky",
                                                                        left: 0,
                                                                        backgroundColor: "#f8f9fa",
                                                                        zIndex: 6,
                                                                        boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    Class
                                                                </th>
                                                                {classSummary.days.map((d, i) => (
                                                                    <th key={i} className="text-center">
                                                                        {d}
                                                                    </th>
                                                                ))}
                                                                <th
                                                                    style={{
                                                                        backgroundColor: "#f8f9fa",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    Avg %
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {classSummary.classes.map((c, i) => (
                                                                <tr
                                                                    key={i}
                                                                    style={{
                                                                        backgroundColor: i % 2 === 0 ? "#ffffff" : "#f9fafb",
                                                                    }}
                                                                >
                                                                    <td
                                                                        className="fw-semibold text-start ps-3"
                                                                        style={{
                                                                            position: "sticky",
                                                                            left: 0,
                                                                            backgroundColor: i % 2 === 0 ? "#ffffff" : "#f9fafb",
                                                                            zIndex: 4,
                                                                            boxShadow: "2px 0 3px rgba(0,0,0,0.03)",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                    >
                                                                        {c.class_name}
                                                                    </td>

                                                                    {c.days.map((val, idx) => (
                                                                        <td key={idx} className="text-center">
                                                                            {val > 0 ? `${val.toFixed(1)}%` : "-"}
                                                                        </td>
                                                                    ))}

                                                                    <td className="fw-bold text-primary">
                                                                        {c.average.toFixed(1)}%
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {monthlyData.daily_summary && (
                                <div className="col-12 mt-4">
                                    <div className="card bg-white rounded-25">
                                        <div className="card-header bg-white rounded-25 text-red">
                                            <h5>Daily Attendance Trend</h5>
                                            <input
                                                type="month"
                                                className="form-control form-control-sm w-auto"
                                                value={selectedMonth}
                                                onChange={(e) => setSelectedMonth(e.target.value)}
                                            />

                                        </div>
                                        <div className="card-body">
                                            {loadingMonthly || !monthlyData.daily_summary ? (
                                                <Skeleton height={300} />
                                            ) : (
                                                <ResponsiveContainer width="100%" height={300}>
                                                    <LineChart data={monthlyData.daily_summary}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="date" />
                                                        <YAxis />
                                                        <Tooltip />
                                                        <Line type="monotone" dataKey="attendance_rate" stroke="#F27121" />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
               
                            {trendRows.length > 0 && (
                                <div className="col-12 mt-4">
                                    <div className="card rounded-25 shadow-sm border-0">
                                        {/* Header */}
                                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                                            <h5 className="text-red mb-0">Attendance & Absence Trends</h5>
                                        </div>

                                        {/* Body */}
                                        <div className="card-body p-4">
                                            <ResponsiveContainer width="100%" height={420}>
                                                <ComposedChart data={combinedTrendData}>
                                                    {/* Grid */}
                                                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

                                                    {/* Axes */}
                                                    <XAxis dataKey="date" tick={{ fontSize: 12, fill: "#6b7280" }} />
                                                    <YAxis tick={{ fontSize: 12, fill: "#6b7280" }} />

                                                    {/* Tooltip */}
                                                    <Tooltip
                                                        formatter={(value, name) => [`${value}%`, name]}
                                                        contentStyle={{
                                                            backgroundColor: "#ffffff",
                                                            borderRadius: "10px",
                                                            border: "1px solid #e5e7eb",
                                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                        }}
                                                        labelStyle={{ fontWeight: "bold", color: "#374151" }}
                                                    />

                                                    {/* Legend */}
                                                    <Legend verticalAlign="top" height={36} iconType="circle" />

                                                    {/* Series: attendance as bar (blue), absences as lines */}
                                                    <Bar
                                                        dataKey="attendance_rate"
                                                        name="Attendance Rate (%)"
                                                        fill="#3B82F6"
                                                        barSize={22}
                                                        radius={[6, 6, 0, 0]} /* round top corners for readability */
                                                    />

                                                    <Line
                                                        type="monotone"
                                                        dataKey="daily_absent_rate"
                                                        name="Daily Absence (%)"
                                                        stroke="#EF4444"
                                                        strokeWidth={3}
                                                        dot={{ r: 2.5 }}
                                                        activeDot={{ r: 6 }}
                                                    />

                                                    <Line
                                                        type="monotone"
                                                        dataKey="progressive_absent_rate"
                                                        name="Progressive Absence (%)"
                                                        stroke="#10B981"
                                                        strokeWidth={3}
                                                        dot={{ r: 2.5 }}
                                                        activeDot={{ r: 6 }}
                                                        opacity={0.9}
                                                    />
                                                </ComposedChart>
                                            </ResponsiveContainer>

                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="col-12 mt-4">
                                <div className="card rounded-25 shadow-sm border-0">
                                    <div
                                        className={`card-header bg-white d-flex ${isMobile ? "flex-column align-items-start gap-2" : "flex-row justify-content-between align-items-center"
                                            }`}
                                    >
                                        <h5 className="text-red mb-0">Forms Monthly Attendance</h5>

                                    </div>


                                    <div className="card-body p-4">
                                        {loadingTrendByForm || trendByForm === null ? (
                                            // Show 6 fake skeleton bars while loading
                                            <div
                                                style={{ height: isMobile ? 300 : 420 }}
                                                className={`d-flex ${isMobile ? "flex-column justify-content-around" : "flex-row align-items-end justify-content-between"} px-3`}
                                            >
                                                {Array.from({ length: 6 }).map((_, idx) => (
                                                    isMobile ? (
                                                        // ✅ Horizontal bars for mobile
                                                        <div
                                                            key={idx}
                                                            className="d-flex align-items-center gap-3 mb-3"
                                                            style={{ width: "100%" }}
                                                        >

                                                            <Skeleton
                                                                width={250}
                                                                height={20}
                                                                style={{ borderRadius: "6px" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        // Vertical bars for desktop
                                                        <Skeleton
                                                            key={idx}
                                                            width={50}
                                                            height={350}
                                                            style={{ borderRadius: "6px" }}
                                                        />
                                                    )
                                                ))}
                                            </div>
                                        ) : Array.isArray(trendByForm) && trendByForm.length > 0 ? (
                                            // Show real chart when data is ready
                                            <ResponsiveContainer width="100%" height={isMobile ? trendByForm.length * 60 : 420}>
                                                <BarChart
                                                    data={trendByForm}
                                                    layout={isMobile ? "vertical" : "horizontal"}
                                                    margin={{ top: 30, right: 30, left: 10, bottom: 20 }}
                                                >
                                                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                                    {isMobile ? (
                                                        <>
                                                            <XAxis
                                                                type="number"
                                                                tick={{ fontSize: 12, fill: "#6b7280" }}
                                                                tickFormatter={(v) => `${v}%`}
                                                            />
                                                            <YAxis
                                                                type="category"
                                                                dataKey="form"
                                                                tick={{ fontSize: 12, fill: "#374151", fontWeight: 600 }}
                                                                width={80}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <XAxis
                                                                dataKey="form"
                                                                tick={{ fontSize: 14, fill: "#374151", fontWeight: 600 }}
                                                            />
                                                            <YAxis
                                                                tick={{ fontSize: 12, fill: "#6b7280" }}
                                                                tickFormatter={(v) => `${v}%`}
                                                            />
                                                        </>
                                                    )}

                                                    <Tooltip
                                                        formatter={(value) => [`${value}%`, "Monthly Attendance"]}
                                                        contentStyle={{
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "10px",
                                                            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                                            padding: "10px 15px",
                                                        }}
                                                        labelStyle={{ fontWeight: "bold", color: "#374151" }}
                                                    />

                                                    <Bar
                                                        dataKey="monthly_attendance_rate"
                                                        name="Monthly Attendance (%)"
                                                        radius={isMobile ? [0, 6, 6, 0] : [10, 10, 0, 0]}
                                                        barSize={isMobile ? 28 : 45}
                                                    >
                                                        {trendByForm.map((entry, index) => (
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={formColorMap[index % formColorMap.length]}
                                                            />
                                                        ))}
                                                        <LabelList
                                                            dataKey="monthly_attendance_rate"
                                                            position={isMobile ? "right" : "top"}
                                                            formatter={(v) => `${v.toFixed(1)}%`}
                                                            style={{
                                                                fill: "#374151",
                                                                fontWeight: "600",
                                                                fontSize: "12px",
                                                            }}
                                                        />
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            // ✅ Show when no data available after loading
                                            <div className="text-center text-muted py-5">
                                                No data available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {
                                attendanceByForm.length > 0 && (
                                    <div className="col-12 mt-4">
                                        <div className="card rounded-25">
                                            <div className="card-header  text-red">
                                                <h5>Attendance Breakdown by Form</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className='row'>
                                                    {attendanceByForm.map((item, index) => (
                                                        <div className="col-12 col-md-6 col-xl-4 mb-4" key={index}>

                                                            <div className="card shadow-sm rounded-25 border-0 bg-white h-100 text-center">

                                                                {/* Banner-style form header */}
                                                                <div
                                                                    className="rounded-top-25 py-2"
                                                                    style={{
                                                                        backgroundColor: getFormColor(index),
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        fontSize: "1.1rem",
                                                                        letterSpacing: "0.5px",
                                                                        textTransform: "uppercase"
                                                                    }}
                                                                >
                                                                    {item.form}
                                                                </div>

                                                                <div className="card-body d-flex flex-column justify-content-between p-4">

                                                                    {/* Circle Progress Bar */}
                                                                    <div className="d-flex justify-content-center mb-4">
                                                                        <div style={{ width: 120, height: 120 }}>
                                                                            <CircularProgressbar
                                                                                value={item.attendance_percentage}
                                                                                text={`${item.attendance_percentage.toFixed(1)}%`}
                                                                                styles={buildStyles({
                                                                                    textColor: "#000",
                                                                                    pathColor: getFormColor(index),
                                                                                    trailColor: "#f1f1f1",
                                                                                    textSize: "20px",
                                                                                    strokeLinecap: "round",
                                                                                })}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Present / Total display */}
                                                                    <div>
                                                                        <div className="h5 text-dark mb-1">
                                                                            {item.total_present} / {item.total_students}
                                                                        </div>
                                                                        <div className="small text-muted">Students Present</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div >
                        <div className="col-12 mt-4">
                            <div className="card rounded-25 shadow-sm border-0">

                                <div className="card-header d-flex flex-row align-items-center justify-content-between bg-white text-red">
                                    <h5 className="mb-0">Location Clusters <span className="badge text-white bg-primary fs-6 px-3 py-2 shadow-sm">
                                        Total Amount: {totalStudentsLocation}
                                    </span>
                                    </h5>
                                    {/* Total Students beside date */}

                                    <input
                                        type="date"
                                        className="form-control form-control-sm w-auto"
                                        value={selectedClusterDate}
                                        onChange={(e) => setSelectedClusterDate(e.target.value)}
                                    />
                                </div>

                                <div className="card-body">
                                    {loadingClusters ? (
                                        <Skeleton height={400} />
                                    ) : locationClusters.length === 0 ? (
                                        <div className="text-muted text-center py-4">
                                            No cluster data available
                                        </div>
                                    ) : (
                                        <MapContainer
                                            center={[3.139, 101.6869]} // fallback center
                                            zoom={16}                 // fallback zoom
                                            scrollWheelZoom={true}
                                            style={{ height: "70vh", width: "100%" }}
                                        >
                                            <TileLayer
                                                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://www.carto.com/">CARTO</a>'
                                                subdomains={['a', 'b', 'c', 'd']}
                                            />


                                            {locationClusters.map((cluster, idx) => (

                                                <Marker
                                                    key={idx}
                                                    position={[cluster.latitude, cluster.longitude]}
                                                    icon={glowingIcon} // 👈 force use glowingIcon instead of default pin
                                                >
                                                    <Popup>
                                                        <b>Gate #{cluster.cluster_id}</b><br />
                                                        Students: {cluster.count}<br />
                                                    </Popup>
                                                </Marker>
                                            ))}


                                            {/* 🔑 Auto-zoom to fit all clusters */}
                                            <FitBounds clusters={locationClusters} />
                                        </MapContainer>

                                    )}
                                </div>
                            </div>
                        </div>

                    </div >
                    <div className="col-12">
                        <div className="card" data-intro="This is Our Topper List">
                            <div className="card-header text-red">
                                <h5>Attendance Breakdown by Class</h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={classes}
                                        striped={true}
                                        center={true}
                                        persistTableHead
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mb-2">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="me-2 fw-semibold">Monthly Filters:</span>

                            {/* Class picker */}
                            <select
                                className="form-select form-select-sm w-auto"
                                value={selectedClassId}
                                onChange={(e) => setSelectedClassId(e.target.value)}
                            >
                                <option value="all">All Classes</option>
                                {classes.map((c) => (
                                    <option key={c.class_id ?? c.id} value={c.class_id ?? c.id}>
                                        {c.class_name}
                                    </option>
                                ))}
                            </select>

                            {/* Month picker */}
                            <input
                                type="month"
                                className="form-control form-control-sm w-auto"
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            />


                            {/* ===== Monthly Class Attendance Report ===== */}
                            {Array.isArray(classMonthlyData?.students) && (
                                <div className="col-12 mt-3">
                                    <div className="card shadow-sm border-0">
                                        {/* Header */}
                                        <div className="card-header bg-white d-flex flex-wrap justify-content-between align-items-center">
                                            <h5 className="text-red mb-0">
                                                {selectedClassId !== "all"
                                                    ? `Monthly Attendance — ${classes.find(c => (c.class_id ?? c.id) === selectedClassId)?.class_name || ""} (${selectedMonth})`
                                                    : `Monthly Attendance (All Classes) — ${selectedMonth}`}
                                            </h5>

                                            <div className="d-flex flex-wrap gap-2">
                                                <div className="d-flex justify-content-center mt-2">
                                                    <span className="badge bg-primary fs-6 px-3">
                                                        Class Avg: {Number(classMonthlyData.classAverageRate ?? 0).toFixed(2)}%
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Body */}
                                        <div className="card-body p-0">
                                            {classMonthlyData.students.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-hover align-middle mb-0">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ minWidth: 220 }}>Student</th>
                                                                <th className="text-center">Present</th>
                                                                <th className="text-center">Total Days</th>
                                                                <th className="text-center">Absent</th>
                                                                <th className="text-center">Attendance %</th>
                                                                <th className="text-center">Amaran Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {classMonthlyData.students.map((s) => (
                                                                <tr key={s.student_id}>
                                                                    {/* Student Info */}
                                                                    <td>
                                                                        <div className="d-flex align-items-center gap-3">
                                                                            {s.profile_pic && (
                                                                                <img
                                                                                    src={s.profile_pic}
                                                                                    alt=""
                                                                                    style={{
                                                                                        width: 40,
                                                                                        height: 40,
                                                                                        borderRadius: "50%",
                                                                                        objectFit: "cover",
                                                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            <div>
                                                                                <div className="fw-semibold">{s.student_name || s.student_id}</div>
                                                                                <div className="text-muted small">{s.student_id}</div>
                                                                            </div>
                                                                        </div>
                                                                    </td>

                                                                    {/* Attendance Numbers */}
                                                                    <td className="text-center fw-semibold">{s.present_days ?? 0}</td>
                                                                    <td className="text-center">{s.total_days ?? 0}</td>
                                                                    <td className="text-center text-danger fw-semibold">
                                                                        {s.absent_days ?? ((s.total_days ?? 0) - (s.present_days ?? 0))}
                                                                    </td>
                                                                    <td className="text-center fw-bold">
                                                                        {Number(s.attendance_rate ?? 0).toFixed(2)}%
                                                                    </td>

                                                                    {/* Amaran Status */}
                                                                    <td className="text-center">
                                                                        <span
                                                                            className={`badge ${(s.amaran_status || "").includes("Buang") ? "bg-danger" :
                                                                                (s.amaran_status || "").includes("Amaran 3") ? "bg-danger" :
                                                                                    (s.amaran_status || "").includes("Amaran 2") ? "bg-warning text-dark" :
                                                                                        (s.amaran_status || "").includes("Amaran 1") ? "bg-warning text-dark" :
                                                                                            "bg-success"
                                                                                } fs-6 px-3 py-2 shadow-sm`}
                                                                        >
                                                                            {s.amaran_status || "Good Standing"}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="p-4 text-center text-muted">
                                                    No student data available for this selection.
                                                </div>
                                            )}
                                        </div>

                                        {/* Footer */}
                                        <div className="card-footer bg-white small text-muted">
                                            <strong>Amaran thresholds:</strong> 3+ days = Amaran 1, 10+ days = Amaran 2,
                                            17+ days = Amaran 3, 31+ days = Amaran 4 (Buang Sekolah).
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* {amaranSchool && (
                        <div className="col-12 my-4">
                            <div className="card rounded-25">
                                <div className="card-header rounded-25 text-danger">
                                    <h5>Surat Amaran Analytics (School-Wide)</h5>
                                    
                                </div>
        
                                <div className="card-body">
                                    <div className="row">
                                        {Object.entries(amaranSchool.stage_totals).map(([stage, count], idx) => (
                                            <div key={stage} className="col-6 col-md-3 mb-3">
                                                <div className="p-3 rounded shadow text-center bg-white">
                                                    <div className="h4 mb-1">{count}</div>
                                                    <div className="small text-muted">{stage}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-4">
                                        <h6>By Class</h6>
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Class Name</th>
                                                        <th>Amaran 1</th>
                                                        <th>Amaran 2</th>
                                                        <th>Amaran 3</th>
                                                        <th>Buang Sekolah</th>
                                                        <th>Tiada Surat Amaran</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {amaranSchool.classes.map(c => (
                                                        <tr key={c.class_id}>
                                                            <td>{c.class_name}</td>
                                                            <td>{c.amaran_counts["Amaran 1"] || 0}</td>
                                                            <td>{c.amaran_counts["Amaran 2"] || 0}</td>
                                                            <td>{c.amaran_counts["Amaran 3"] || 0}</td>
                                                            <td>{c.amaran_counts["Buang Sekolah"] || 0}</td>
                                                            <td>{c.amaran_counts["Tiada Surat Amaran"] || 0}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )} */}

                </div >
            </div >
        </Fragment >
    );
}

export default Homepage;

const DashboardCard = (props) => {
    //null,"dark"
    const [cardClassName] = useState(props.theme || "");
    return (
        <div className={"card rounded-25 text-center " + cardClassName}>
            <div className="card-body">
                <div className="">
                    <div className="mb-0 mainComponent">
                        {props.mainComponent}
                    </div>
                    <div className='subComponent pt-3'>
                        {props.subComponent}
                    </div>
                </div>
            </div>
        </div>
    )
}